import Home from './home';
import Contato from './contato';
import Abertas from './abertas';
import Comanda from './comanda';
import Pendentes from './pendentes';

const routes = [...Home, ...Contato, ...Abertas, ...Comanda, ...Pendentes];

export default routes;
